// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"775038fd","239":"4395d5f6","455":"650042c2"}[chunkId] + ".chunk.js";
};